import { statuses } from '../../../constants/project';
import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';
import { RouterContext } from '../../../types/router';
import { loadSdk } from '../../files/files.actions';
import { getDefaultProject } from '../../projects/projects.selectors';
import { Dispatch, GetState } from '../../redux.types';

import { getProjectsData } from './projects';
import { buildLoadDataCachedFn, fetchDataOnProjectChange } from './utils/utils';

/**
 * Only loads  common data for FileManager. Doesn't load files itself.
 * This is needed in order to show 2 different spinners: one for whole screen and
 * another for files list
 */
export const getCommonDataForFileManagerFunction = (
  routerContext: RouterContext,
  dispatch: Dispatch,
  getState,
) => {
  const organizationId = getSelectedOrganizationId(getState(), {
    router: routerContext,
  });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return dispatch(getProjectsData(routerContext)).then((): any => {
    const updatedState = getState();
    const project = getDefaultProject(updatedState, {
      router: routerContext,
    });

    if (!project || project.status !== statuses.READY) {
      return null;
    }

    return loadSdk(organizationId, project);
  });
};

const loadCommonDataCached = buildLoadDataCachedFn(
  getCommonDataForFileManagerFunction,
  fetchDataOnProjectChange,
);

export const loadCommonDataForFileManagerRoute =
  (context: RouterContext) => (dispatch: Dispatch, getState: GetState) => {
    return loadCommonDataCached(context, dispatch, getState);
  };
